import * as types from "./actionTypes";

const INITIAL_STATE = {
  role: null,
  permissions: [],
  loadingPermissions: true,
};

export default function PermissionReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case types.FETCH_PERMISSIONS_REQUEST:
      return {
        ...state,
        loadingPermissions: true,
      };

    case types.FETCH_PERMISSIONS_SUCCESS:
      return {
        ...state,
        role: action.payload.role,
        permissions: action.payload.permissions,
        loadingPermissions: false,
      };

    case types.FETCH_PERMISSIONS_FAILURE:
      return {
        ...state,
        role: null,
        permissions: [],
        loadingPermissions: false,
      };

    default:
      return state;
  }
}
